/**
 * Desktop sidebar collapse state for the console AppShell. Persisted to
 * localStorage so the choice survives reloads (mirrors admin-web's
 * `collapsible="icon"` sidebar). Only affects ≥lg; mobile uses the bottom nav.
 */
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type SidebarState = {
  collapsed: boolean;
  toggle: () => void;
};

export const use_sidebar_store = create<SidebarState>()(
  persist(
    (set, get) => ({
      collapsed: false,
      toggle: () => set({ collapsed: !get().collapsed }),
    }),
    { name: 'pet-marketplace-console-sidebar' },
  ),
);
